var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Song } from '@ddradar/core';
import { Component, Vue } from 'nuxt-property-decorator';
import { searchSong } from '~/api/song';
import SongList from '~/components/pages/songs/SongList.vue';
let SongByNamePage = class SongByNamePage extends Vue {
    constructor() {
        super(...arguments);
        /** Song List from API */
        this.songs = [];
    }
    /** Name index title (like "あ", "A", "数字・記号") */
    get title() {
        return Song.nameIndexMap.get(this.selected);
    }
    get selected() {
        return parseInt(this.$route.params.nameIndex, 10);
    }
    /** "あ", ..., "A", ..., "数字・記号" */
    get nameIndexList() {
        return [...Song.nameIndexMap.values()];
    }
    /** nameIndex should be [0-36] */
    validate({ params }) {
        const parsedIndex = parseInt(params.nameIndex, 10);
        return (/^\d{1,2}$/.test(params.nameIndex) &&
            parsedIndex >= 0 &&
            parsedIndex < Song.nameIndexMap.size);
    }
    /* istanbul ignore next */
    head() {
        return { title: this.title };
    }
    /** Get Song List from API */
    async fetch() {
        this.songs = await searchSong(this.$http, this.selected);
    }
};
SongByNamePage = __decorate([
    Component({ components: { SongList }, fetchOnServer: false })
], SongByNamePage);
export default SongByNamePage;
